export class DataRec {
  FirstText;
  SecondText;
  ImageIdentifier;

  constructor() {
    this.SecondText = "היי, נשמח לעדכן את הפרטים שלך אצלנו";
    this.setImageIdentifier();
  }

  async setImageIdentifier() {
    this.ImageIdentifier = await ImageHandler();
  }
}

const ImageHandler = async () => {
  return "DataRec/DataRec.png";
};
